import BasicService from "./BasicService";

class CollectService extends BasicService {
  constructor() {
    super();
  }

  /**
   *
   * @param {Number} itemId
   */
  getCollectByItemId(itemId) {
    let url = `/orders/${itemId}/collects`;
    return this.axios.get(url).then(response => response.data);
  }
  /**
   *
   * @param {Number} itemId
   * @param {Object} collect -
   * {"itemId": Number,"collectId": Number,"employeeDto": {"userAccountId": Number,},"remark": String,"collectDate": "DD-MM-YYYY"}
   */
  saveCollect(itemId, collect) {
    let url = `/orders/${itemId}/collects`;
    return this.axios.post(url, collect).then(response => response.data);
  }

  /**
   *
   * @param {Number} itemId
   * @param {Number} collectId - collectId must require
   * @param {Object} collect -
   * {"itemId": Number,"collectId": Number,"employeeDto": {"userAccountId": Number,},"remark": String,"collectDate": "DD-MM-YYYY"}
   */
  updateCollect(itemId, collectId, collect) {
    let url = `/orders/${itemId}/collects/${collectId}`;
    return this.axios.put(url, collect).then(response => response.data);
  }

  getCollectedItemDetailByItemId(itemId) {
    let url = `/orders/${itemId}/itemdetail`;
    return this.axios.get(url).then(response => response.data);
  }
  /**
   *
   * @param {Number} itemId
   * @param {Object} itemDetail - 
   * {"itemId": Number,"itemName": String,"weight": String,"osPayment": boolean,"customerPayment": boolean,"remark": String,"amount": Number,"itemValue": Number,"fromOSId": Number}
}
   */
  saveCollectedItemDetail(itemId, itemDetail) {
    let url = `/orders/${itemId}/itemdetail`;
    return this.axios.post(url, itemDetail).then(response => response.data);
  }

  updateCollectedItemDetail(itemId, transactionId, itemDetail) {
    let url = `/orders/${itemId}/itemdetail/transactions/${transactionId}`;
    return this.axios.put(url, itemDetail).then(response => response.data);
  }

  saveMultipleCollectedItem(itemId, listCollectedItem){
    let url = `/orders/${itemId}/itemdetail/multi`;
    return this.axios.post(url, listCollectedItem).then(response => response.data);
  }

  getMultiCollectedItemDetailByItemId(itemId){
    let url = `/orders/${itemId}/itemdetail/multi`;
    return this.axios.get(url).then(response => response.data);
  }

  updateSingleCollectedItem(itemId, collectedItem){
    let url = `/orders/${itemId}/itemdetail/multi`;
    return this.axios.put(url, collectedItem).then(response => response.data);
  }
}

const collectService = new CollectService();
export default collectService;
